'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  user-select: none;\n  padding: 20px;\n  background-color: #F8FAFC;\n  box-shadow: inset 0px 11px 8px -10px #cbd6db;\n  border: 1px solid #B9C5CD;\n  border-top: none;\n  border-radius: 0 0 6px 6px;\n'], ['\n  user-select: none;\n  padding: 20px;\n  background-color: #F8FAFC;\n  box-shadow: inset 0px 11px 8px -10px #cbd6db;\n  border: 1px solid #B9C5CD;\n  border-top: none;\n  border-radius: 0 0 6px 6px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InnerContent = _styledComponents2.default.div(_templateObject);

InnerContent.displayName = 'InnerContent';

exports.default = InnerContent;
//# sourceMappingURL=InnerContent.js.map


//////////////////
// WEBPACK FOOTER
// ../card-drawer/lib/InnerContent.js
// module id = 152
// module chunks = 0